export default {
  items: !process.env.VUE_APP_TOKEN_AUTH_ONLY ? [
    { name: 'Sign In', icon: 'fal fa-sign-in', url: '/login' },
    { name: 'Register', icon: 'fal fa-user-plus', url: '/register' },
    { name: 'Submit', icon: 'fal fa-plus', url: '/submissions/add' },
    { name: 'Products', icon: 'fal fa-cubes', url: '/products' },
    { name: 'Instructions', icon: 'fal fa-file', url: '/instructions' },
  ] : []
}
